import React from 'react';
import classNames from 'classnames';
const Subtitle = ({ className, children }) => (<div className={classNames('small text-muted', className)}>{children}</div>);
Subtitle.defaultProps = {
    className: '',
};
export default Subtitle;
